import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

const RiversideDetails = () => {
  const [cookies] = useCookies(["token", "user", "id"]);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");

  const user_id = cookies.id;

  const destinations = [
    {
      name: "Varanasi",
      img: "varanasi.jpg",
      desc: "The spiritual capital of India on the banks of the Ganges, famous for ghats and Ganga Aarti.",
    },
    {
      name: "Rishikesh",
      img: "Rishikesh.jpg",
      desc: "Yoga capital of the world on the Ganges, known for rafting and ashrams.",
    },
    {
      name: "Haridwar",
      img: "haridwar.jpg",
      desc: "Holy city where the Ganga enters the plains, famous for evening Aarti.",
    },
    {
      name: "Maheshwar",
      img: "maheshwar.jpg",
      desc: "Sacred town on the Narmada River with beautiful ghats and fort architecture.",
    },
    {
      name: "Hampi",
      img: "hampi.jpg",
      desc: "Ancient ruins and temples along the Tungabhadra River in Karnataka.",
    },
    {
      name: "Kochi",
      img: "Kochi.jpg",
      desc: "Historic port city with backwaters, Chinese fishing nets and colonial charm.",
    },
    {
      name: "Vietnam",
      img: "vietnam-river.jpg",
      desc: "Scenic river cruises and floating markets along the Mekong River.",
    },
    {
      name: "Synopsis Riverside",
      img: "synopsis.jpg",
      desc: "A peaceful riverside retreat ideal for relaxation, nature and calm surroundings.",
    },
  ];

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://www.api.aacoreholidaysresort.com/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: "rzp_live_RAfef3cbQ27N9l",
        amount: data.amount,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: `${selectedDestination} Riverside Booking`,
        order_id: data.orderId,
        handler: async function (response) {
          await fetch(
            "https://www.api.aacoreholidaysresort.com/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );
          alert("Payment successful 🎉");
          setShowModal(false);
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  return (
    <div id="riversidedetails">
      <div
        className="riversidedetails-banner py-5"
        style={{
          backgroundImage: "url(/assets/images/river.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item text-light">
              <Link to="/travelthemes" className="text-light">
                Travel Theme
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Riverside</li>
          </ol>
        </nav>
      </div>

      <div className="container mt-5">
        <h1 className="text-center mb-4">Riverside Destinations</h1>

        <div className="row">
          {destinations.map((place, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card">
                <img
                  src={`/assets/images/${place.img}`}
                  className="card-img-top"
                  style={{ height: "250px", objectFit: "cover" }}
                  alt={place.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{place.name}</h5>
                  <p className="card-text">{place.desc}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setSelectedDestination(place.name);
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Book {selectedDestination} Riverside Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RiversideDetails;
